import { logActivity } from '../api/user.js'

export function logUserActivity (path, name, id, origin = '') {
  // Strip any trailing slashes
  path = path.replace(/\/$/, '')

  if (name === 'fileDetail') {
    path = path.replace('/analysis', '')

    id = path.substr(path.lastIndexOf('/') + 1)
  }

  if (path && userActivityPages.includes(path)) {
    if (id) {
      logActivity(path, id, origin)
    } else {
      logActivity(path, '', origin)
    }
  } else if (name && userActivityPages.includes(name)) {
    if (id) {
      logActivity(name, id, origin)
    } else {
      logActivity(name, '', origin)
    }
  }
}

export const userActivityPages = [
  '/actors',
  '/announcements',
  '/events',
  '/events-simplified',
  '/dashboards/analytics',
  '/dashboards/business-size',
  '/dashboards/digital-footprint',
  '/dashboards/home',
  '/dashboards/knowledge-base',
  '/datalab/curation',
  '/datalab/spreadsheet',
  '/datalab/suggestions',
  '/settings/users',
  'actor-detail',
  'announcements-detail',
  'challenges-detail',
  'file-detail', // Clicking view on Announcement Or Resource card
  'fileDetail', // Article analysis page
  '/challenges',
  '/actors-simplified',
  '/products-simplified',
  '/announcements-simplified',
  '/product-gallery',
  'knowledge-base-detail',
]

export function humanizeUserActivity (activity) {
  var mapping = {
    'home_page': 'home page',
    'directory': 'directory',
    'actor_detail': 'actor profile',
    'social_monitoring': 'buzz',
    'announcements': 'announcements overview',
    'announcements_detail': 'specific announcements',
    'analytics': 'analytics',
    'digital_footprint': 'digital footprint scores',
    'business_size': 'business size scores',
    'buzz': 'buzz',
    'knowledge_base': 'knowledge base',
    'user_settings': 'users panel',
    'curation': 'curation panel',
    'suggestions': 'suggestions panel',
    'spreadsheet': 'spreadsheet panel',
    'create_actor': 'Created an actor',
    'update_actor': 'Updated an actor',
    'create_announcement': 'Created an announcement',
    'update_announcement': 'Updated an announcement',
    'create_resource': 'Created a resource',
    'update_resource': 'Updated a resource',
    'create_challenge_comment': 'Created a comment on a challenge',
    'remove_challenge_comment': 'Removed a comment on a challenge',
    'challenges_overview': 'challenges overview',
    'products_simplified': 'product overview',
    'actors_simplified': 'actors overview',
  }

  if (mapping[activity]) {
    return mapping[activity]
  }

  return activity
}

export function humanizeUserActivityDescription (activity, user) {
  var mapping = {
    'home_page': 'home page',
    'directory': 'directory',
    'actor_detail': 'actor profile',
    'social_monitoring': 'buzz',
    'announcements': 'announcements overview',
    'announcements_detail': 'specific announcements',
    'analytics': 'analytics',
    'digital_footprint': 'digital footprint scores',
    'business_size': 'business size scores',
    'buzz': 'buzz',
    'knowledge_base': 'knowledge base',
    'user_settings': 'users panel',
    'curation': 'curation panel',
    'suggestions': 'suggestions panel',
    'spreadsheet': 'spreadsheet panel',
    'create_actor': 'Created an actor',
    'update_actor': 'Updated an actor',
    'create_announcement': 'Created an announcement',
    'update_announcement': 'Updated an announcement',
    'create_resource': `${user} has created a resource`,
    'delete_resource': `${user} has deleted a resource`,
    'create_challenge_comment': `${user} has commented on a challenge`,
    'remove_challenge_comment': `${user} has removed a comment on a challenge`,
    'challenges_overview': 'challenges overview',
    'products_simplified': 'product overview',
    'actors_simplified': 'actors overview',
  }

  if (mapping[activity]) {
    return mapping[activity]
  }

  return activity
}
